import { captureMarketing } from "./analytics.js"
import { ctaProperties } from "./marketing_attribution.js"

export function isScheduler(url) {
  return url.protocol === "https:" && url.hostname === "savvycal.com" &&
    ["/jgtr/chat", "/jgtr/chat/"].includes(url.pathname)
}

export default function setupMarketingCtas(doc = document, win = window, capture = captureMarketing) {
  const track = (event, fields) => { try { capture(event, fields) } catch { /* Navigation always wins. */ } }
  const activate = event => {
    if (event.defaultPrevented || (event.type === "auxclick" ? event.button !== 1 : event.button !== 0)) return
    const link = event.target.closest?.("a[href]")
    if (!link || link.hasAttribute("download")) return
    let url
    try { url = new URL(link.href, win.location.href) } catch { return }
    const scheduler = isScheduler(url)
    const inquiry = url.origin === win.location.origin && /\/contact-us\/?$/.test(url.pathname)
    const id = link.dataset.cta || (inquiry ? url.searchParams.get("cta") : null) ||
      ((scheduler || inquiry) ? link.closest("[data-cta-scope]")?.dataset.ctaScope : null)
    const fields = ctaProperties(id)
    if (fields.cta_id !== "unannotated") track("marketing_cta_clicked", fields)
    if (!scheduler) return
    const modified = event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0
    if (!modified && !link.hasAttribute("data-booking-direct") && doc.getElementById("discovery-qualifier")) {
      event.preventDefault()
      win.dispatchEvent(new CustomEvent("open-qualifier"))
    } else {
      track("booking_outbound_clicked", fields)
    }
  }
  doc.addEventListener("click", activate)
  doc.addEventListener("auxclick", activate)
  win.addEventListener("telos:questionnaire-booking", () =>
    track("booking_outbound_clicked", ctaProperties("questionnaire-completed")))
}
